import { useContext, useState, createContext, useEffect } from 'react';

import { getUserInStorage } from 'lib/Storage';

const defualtValue = getUserInStorage() || {};

// initialize user context
const UserContextValue = createContext(defualtValue);
const UserContextSetState = createContext(() => null);

function UserProvider({ children, user = defualtValue }) {
  const [_user, setUser] = useState(user);
  console.log("*****",user, _user)
  useEffect(() => {
    setUser(user);
  }, [user]);
  return (
    <UserContextValue.Provider value={_user}>
      <UserContextSetState.Provider value={setUser}>{children}</UserContextSetState.Provider>
    </UserContextValue.Provider>
  );
}

function useUserState() {
  const user = useContext(UserContextValue);
  const setUser = useContext(UserContextSetState);
  const state = [user, setUser];
  return state;
}

function useUserValue() {
  const user = useContext(UserContextValue);
  return user;
}

function useIsAdmin() {
  const user = useContext(UserContextValue);
  // console.log("userIS:",user)
  if (user === undefined) {
    throw new Error('user must be used within a CountProvider');
  }
  // console.log(user.type)
  const isAdmin = user?.type === 'superAdmin' || user?.type === 'personnel';
  return isAdmin;
}

function useIsSuperAdmin() {
  const user = useContext(UserContextValue);
  // console.log("userIS:",user)
  if (user === undefined) {
    throw new Error('user must be used within a CountProvider');
  }
  // console.log(user.type)
  const isSuperAdmin = user?.type === 'superAdmin' 
  return isSuperAdmin;
}

function useUserSetState() {
  const setUser = useContext(UserContextSetState);
  return setUser;
}


export {
  UserProvider,
  useUserState,
  useUserValue,
  useUserSetState,
  useIsAdmin,
  useIsSuperAdmin
};
